/* eslint-disable no-console */
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import ReduxStateDebugger from './ReduxStateDebugger'

declare global {
  interface Window {
    enableReduxStateDebug?: () => void
    disableReduxStateDebug?: () => void
  }
}

let isDebuggerEnabled = false

// Function to be called from console to toggle the debugger
export const enableReduxStateDebug = (): void => {
  isDebuggerEnabled = true
  if (typeof window !== 'undefined') {
    const event = new Event('redux-debug-toggle')
    window.dispatchEvent(event)
    console.log('Redux State Debugger enabled')
  }
}

export const disableReduxStateDebug = (): void => {
  isDebuggerEnabled = false
  if (typeof window !== 'undefined') {
    const event = new Event('redux-debug-toggle')
    window.dispatchEvent(event)
    console.log('Redux State Debugger disabled')
  }
}

if (typeof window !== 'undefined') {
  try {
    window.enableReduxStateDebug = enableReduxStateDebug
    window.disableReduxStateDebug = disableReduxStateDebug
  } catch (e) {
    console.warn('Unable to add Redux State Debugger functions to window object:', e)
  }
}

const ReduxStateDebuggerProvider: React.FC = () => {
  const [isVisible, setIsVisible] = useState(isDebuggerEnabled)

  useEffect(() => {
    const handleToggle = () => {
      setIsVisible(isDebuggerEnabled)
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('redux-debug-toggle', handleToggle)

      try {
        window.enableReduxStateDebug = enableReduxStateDebug
        window.disableReduxStateDebug = disableReduxStateDebug
      } catch (e) {
        console.warn('Unable to add Redux State Debugger functions to window:', e)
      }

      return () => {
        window.removeEventListener('redux-debug-toggle', handleToggle)
      }
    }
  }, [])

  const handleClose = () => {
    isDebuggerEnabled = false
    setIsVisible(false)
    console.log('Redux State Debugger closed')
  }

  if (!isVisible) {
    return null
  }

  // Create portal to render at the document body level
  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(
      <ReduxStateDebugger onClose={handleClose} />,
      document.body,
    )
  }

  return null
}

export default ReduxStateDebuggerProvider
